import { createContext } from 'react';

const PaymentsContext = createContext();

export default PaymentsContext;
